import { render, staticRenderFns } from "./customerView.vue?vue&type=template&id=e15920ba&"
import script from "./customerView.vue?vue&type=script&lang=js&"
export * from "./customerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports